import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/banners`;

const BannerManager = {
  async getAllBanners() {
    const { data } = await axios.get(BASE_URL);
    return data.responseData;
  },

  async getBannerById(id) {
    const { data } = await axios.get(`${BASE_URL}/${id}`);
    return data.responseData;
  },

};

export default BannerManager;
